import { render, staticRenderFns } from "./Suswindow.vue?vue&type=template&id=fc06214c&"
import script from "./Suswindow.vue?vue&type=script&lang=js&"
export * from "./Suswindow.vue?vue&type=script&lang=js&"
import style0 from "./Suswindow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports